export const tableLocation = {
    data() {
        return {
            tableColumns: [
                { title: this.$t('country'), type: 'text', key: 'country' },
                { title: this.$t('state'), type: 'text', key: 'state' },
                { title: this.$t('city'), type: 'text', key: 'city' },
                { title: this.$t('action'), type: 'action', key: 'action' },
            ]
        };
    }
}